import { useStaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React from 'react'

const StoreHighlightImage = ({ name }) => {
  const data = useStaticQuery(graphql`
    query {
      amazonLockers: file(relativePath: { eq: "amazonLockers.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      asianClothing: file(relativePath: { eq: "asianClothing.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      butcher: file(relativePath: { eq: "butcher.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      CarStoreConnect: file(relativePath: { eq: "CarStoreConnect.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      clickAndCollect: file(relativePath: { eq: "clickAndCollect.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      coffeeToGo: file(relativePath: { eq: "coffeeToGo.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      doddleParcels: file(relativePath: { eq: "doddleParcels.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      fishmonger: file(relativePath: { eq: "fishmonger.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      flowerWrapping: file(relativePath: { eq: "flowerWrapping.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      freeFrom: file(relativePath: { eq: "freeFrom.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      freshToGo: file(relativePath: { eq: "freshToGo.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      halalCounter: file(relativePath: { eq: "halalCounter.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      hotFood: file(relativePath: { eq: "hotFood.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      makeYourOwnPizza: file(relativePath: { eq: "makeYourOwnPizza.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      marketKitchen: file(relativePath: { eq: "marketKitchen.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      newLookCafe: file(relativePath: { eq: "newLookCafe.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      nutmeg: file(relativePath: { eq: "nutmeg.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      nutmegWomens: file(relativePath: { eq: "nutmegWomens.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      pancakes: file(relativePath: { eq: "pancakes.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      partyShop: file(relativePath: { eq: "partyShop.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      saladBar: file(relativePath: { eq: "saladBar.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      sushi: file(relativePath: { eq: "sushi.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      timpson: file(relativePath: { eq: "timpson.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      wifi: file(relativePath: { eq: "wifi.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      worldFoods: file(relativePath: { eq: "worldFoods.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      brew: file(relativePath: { eq: "brew.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      charAndSmoke: file(relativePath: { eq: "charAndSmoke.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      bespokeHighlights: file(relativePath: { eq: "bespokeHighlights.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      electricVehicleCharging: file(
        relativePath: { eq: "electricVehicleCharging.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
    }
  `)

  const image = getImage(data?.[name])

  return <GatsbyImage image={image} alt={`${name} image`} />
}

export default StoreHighlightImage
